import { Box } from '@mui/material';
import React, { useState } from 'react';

import { LAYOUT } from 'components/Layout';

import { IconWrapper } from 'components/Icon';

export const BlogPicture = ({ sx = {}, picture }) => {
  return (
    <>
      <Box
        width={'calc(100% - 2*3*8px)'}
        minHeight={LAYOUT.largeHeaderHeight}
        // position="absolute"
        top={0}
        left={0}
        sx={({ spacing }) => ({
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          cursor: 'default',
          overflow: 'hidden',
          mx:3,

          img: {
            height: 1,
            width: 1,
          },
        })}
      >
        {!picture && (
          <IconWrapper
            icon="photo"
            sx={{ svg: { width: 80, height: 80, mt: -4, stroke: 'white', color: 'white' } }}
          />
        )}

        {picture && <img src={picture} alt="banner" />}
      </Box>
    </>
  );
};
